import React, {useContext, useMemo} from "react";
import DeviceSimulator from "../../../../components/base/device-simulator";
import {UserHomepageStateContext, UserHomepageViewContext} from "../../index";
import UserPhoneHomepageHeader from "./sections/header";
import {CircularProgress} from "@mui/material";
import UserPhoneHomepageFooter from "./sections/footer";
import UserPhoneHomepageBody from "./sections/body";

const UserPhoneHomepage = ({id}) => {
    const viewContext = useContext(UserHomepageViewContext);
    const state = useContext(UserHomepageStateContext);
    const loading = useMemo(() => !state.updatedData, [state.updatedData])

    return (
        <>
            <DeviceSimulator
                id={id}
                zoom={viewContext.zoom}
                className={'phone-simulator user-phone-homepage'}
                device={'iPhone X'}
            >
                <UserPhoneHomepageHeader/>
                {
                    loading &&
                    <div
                        className={'d-flex flex-column justify-content-center align-items-center flex-grow-1'}>
                        <CircularProgress size={40}/>
                    </div>
                }
                {
                    !loading &&
                    <UserPhoneHomepageBody/>
                }
                <UserPhoneHomepageFooter/>
            </DeviceSimulator>
        </>
    )
}

export default UserPhoneHomepage;
